import React, { useEffect } from "react";

const NotFound = () => {
  useEffect(() => { document.title = "404 — Page Not Found | Piatto"; }, []);
  return <div role="main">NotFound</div>;
};

export default NotFound;
